import React from 'react'


interface SpinnerDetails {
    type?: string;
    size?: string;
}

const Spinner = ({type = 'border', size = 'sm'}: SpinnerDetails) => {
  return (
    <div className={`spinner-${type} spinner-${type}-${size} text-primary mr-2`} role='status'>
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}

export default Spinner
